export default {
  defaultFormat: 'DD MMM YYYY', // 01-31 Jan-Dec 1970-2030
  monthYear: 'MMMM YYYY', // January-December
  dayMonthYearFormat: 'DD MMMM YYYY', // // 01-31 January-December 1970-2030
};
